import endpoints from '@app/src/api/endpoints'
import useApi from '@app/src/hooks/api'
import { useConfirm } from 'material-ui-confirm'
import { useIntl } from 'react-intl'

export const useRepositoryFileReplacement = () => {
  const { get } = useApi()
  const confirm = useConfirm()
  const { formatMessage, formatList } = useIntl()

  const fetchRepositoryFileNames = async () => {
    const repositoryFileNames = await get<string[]>({ url: endpoints.suggestionFileNames })
    return new Set(repositoryFileNames)
  }

  const confirmReplacing = async (fileNames: string[]) => {
    try {
      await confirm({
        title: formatMessage({ id: 'suggestedAnswers.replaceFile.title' }, { count: fileNames.length }),
        description: formatMessage(
          { id: 'suggestedAnswers.replaceFile.description' },
          { count: fileNames.length, fileNames: formatList(fileNames, { type: 'conjunction' }) },
        ),
        confirmationText: formatMessage({ id: 'suggestedAnswers.replaceFile.confirm' }),
        cancellationText: formatMessage({ id: 'suggestedAnswers.replaceFile.keepExisting' }),
        cancellationButtonProps: { variant: 'contained' },
        confirmationButtonProps: { variant: 'text' },
        buttonOrder: ['confirm', 'cancel'],
      })
      return true
    } catch {
      return false
    }
  }

  return { fetchRepositoryFileNames, confirmReplacing }
}
